import { render, staticRenderFns } from "./RoleLibNew.vue?vue&type=template&id=58156318&scoped=true"
import script from "./RoleLibNew.vue?vue&type=script&lang=js"
export * from "./RoleLibNew.vue?vue&type=script&lang=js"
import style0 from "./RoleLibNew.vue?vue&type=style&index=0&id=58156318&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58156318",
  null
  
)

export default component.exports